/**
 * Premium Lite: the member's plan as the backend reports it (`plan` in the
 * permissions list, `access_info.plan` on the profile). A Lite member still
 * has subscription type / user_type "premium", so screens that must tell Lite
 * from Premium read the plan, never the type.
 */
export const MEMBER_PLAN = {
  GUEST: "guest",
  FREE: "free",
  PREMIUM_LITE: "premium_lite",
  PREMIUM: "premium",
};

const RANK = { guest: 0, free: 1, premium_lite: 2, premium: 3 };

export const planRank = (plan) => RANK[plan] ?? 0;

/** Older backends send only user_type (guest/free/premium). */
export const planFromUserType = (userType) => {
  if (userType === "premium") return MEMBER_PLAN.PREMIUM;
  if (userType === "free") return MEMBER_PLAN.FREE;
  return MEMBER_PLAN.GUEST;
};

export const isPaidPlan = (plan) =>
  plan === MEMBER_PLAN.PREMIUM || plan === MEMBER_PLAN.PREMIUM_LITE;

export const planLabel = (plan) =>
  ({
    guest: "Guest",
    free: "Free",
    premium_lite: "Premium Lite",
    premium: "Premium",
  })[plan] ?? "";

/**
 * What a fresh Premium Lite purchase may NOT open before the backend confirms:
 * the CRM matrix defaults for Lite (client, 14/10/2026). The canonical levels
 * replace these as soon as /api/app/permissions/list answers.
 */
export const LITE_LOCKED_PERMISSION_SLUGS = [
  "diet_plan.open_magazine",
  "diet_plan.search_recipes",
  "diet_plan.advanced_recipe_filters",
  "diet_plan.all_journeys",
  "streaming_videos.movement_library",
];

/**
 * The plan a store SKU sells. Premium and Premium Lite share the RevenueCat
 * entitlement `master_club_premium`, so right after a purchase or a restore
 * only the SKU tells them apart: Lite SKUs are `dietasocial.lite.*` (Google
 * may append `:<base plan>`). The backend reads the tier from its own product
 * row; this only steers the optimistic state until it answers.
 */
export const planForStoreProductId = (productId) =>
  String(productId || "")
    .trim()
    .toLowerCase()
    .startsWith("dietasocial.lite.")
    ? MEMBER_PLAN.PREMIUM_LITE
    : MEMBER_PLAN.PREMIUM;
